
import * as FrustumRegionWorker from './frustumRegionWorker';
import * as FrustumMeshWorker from './frustumRegionWorker';
import * as FrustumStructures from './frustumStructures';
import * as BABYLON from 'babylonjs';
export var CollisionWorker = "";

export interface IFrustumRegionCoordinator {

    getUpdatedNodeStatus(collisionIndex: number, maximumRetry: number, cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, planes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, lodDistances: number[], onUpdatedNodes: (sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TileNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TileNode>) => any): void;
    init(sceneManager: any, scene: BABYLON.Scene): void;
    destroy(): void;
    onNodeRemoved(node: FrustumStructures.TileNode): void;

    onOctreeBlockContentAdded(node: FrustumStructures.TileNode): void;
    onNodeRemoved(node: FrustumStructures.TileNode): void;
}

export interface FrustmMeshMessage {
    taskType: WorkerTaskType;
    payload: InitPayload | FrustumStructures.FrustumRegionPayload | UpdatePayload /*any for TS under 1.4*/;
}

export interface SerializedFrustumRegionToWorker {
    // Cam properties
}

export enum WorkerTaskType {
    INIT,
    UPDATE,
    ORDERNODES
}

export interface WorkerReply {
    error: WorkerReplyType;
    taskType: WorkerTaskType;
    payload?: any;
}

export interface InitPayload {

}

export interface UpdatePayload {

    updatedBlocks: FrustumRegionWorker.OctreeBlock<FrustumStructures.TileNode>[];
    updatedBlockContent: { [n: string]: FrustumStructures.TileNode; };
    removedNodes: Array<string>;
}

export enum WorkerReplyType {
    SUCCESS,
    UPDATE,
    ORDERNODES,
    UNKNOWN_ERROR
}

export class FrustumRegionCoordinatorWorker implements IFrustumRegionCoordinator {

    private _scene: BABYLON.Scene;
    private _sceneManager: any;
    private _scaledPosition = BABYLON.Vector3.Zero();
    private _scaledVelocity = BABYLON.Vector3.Zero();

    private _updateNodesCallbackArray: Array<(sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TileNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TileNode>) => void>;
    private _init: boolean;
    private _runningUpdated: number;
    private _runningCollisionTask: boolean;
    private _worker: Worker;

    private _blockContentToAdd: { [n: string]: FrustumStructures.TileNode; }
    private _blocksToAdd: FrustumRegionWorker.OctreeBlock<FrustumStructures.TileNode>[] = [];

    private _addUpdateNodeList: { [n: string]: FrustumStructures.TileNode; }
    private _toRemoveNodesArray: Array<string>;

    constructor() {
        this._updateNodesCallbackArray = [];
        this._init = false;
        this._runningUpdated = 0;
        this._runningCollisionTask = false;
    }

    public getUpdatedNodeStatus(collisionIndex: number, maximumRetry: number, cameraPosition: BABYLON.Vector3, cameraDirection: BABYLON.Vector3, planes: BABYLON.Plane[], transformation: number[], viewport: BABYLON.Viewport, lodDistances : number[], onUpdatedNodes: (sceneManager: any, visibleNodes: BABYLON.SmartArray<FrustumStructures.TileNode>, hiddenNodes: BABYLON.SmartArray<FrustumStructures.TileNode>) => any): void {
        if (!this._init) return;

        if (this._updateNodesCallbackArray[collisionIndex] || this._updateNodesCallbackArray[collisionIndex + 100000]) return;

        this._updateNodesCallbackArray[collisionIndex] = onUpdatedNodes;


        var payload: FrustumStructures.FrustumRegionPayload = {

            planes: planes,
            cameraPosition: cameraPosition,
            cameraDirection: cameraDirection,
            collisionId: collisionIndex,
            maximumRetry: maximumRetry,
            transformation: transformation,
            viewport: viewport,
            lodDistances: lodDistances
        };

        var message: FrustmMeshMessage = {
            payload: payload,
            taskType: WorkerTaskType.ORDERNODES
        }
        this._worker.postMessage(message);

    }

    public init(sceneManager: any, scene: BABYLON.Scene): void {
        this._scene = scene;
        this._sceneManager = sceneManager;
        this._scene.registerAfterRender(this._afterRender);

        this._blockContentToAdd = {};
        this._blocksToAdd = [];

        this._worker = new Worker(new URL('./frustumRegionWorker.ts', import.meta.url), { type: 'module' });
        this._worker.onmessage = this._onMessageFromWorker;
        var message: FrustmMeshMessage = {
            payload: {},
            taskType: WorkerTaskType.INIT
        }

        this._worker.postMessage(message);
    }

    public destroy(): void {
        this._scene.unregisterAfterRender(this._afterRender);
        this._worker.terminate();
    }


    OnOctreeBlockAdded(block: FrustumRegionWorker.OctreeBlock<FrustumStructures.TileNode>) {

        this._blocksToAdd.push(block);
    }
    public onOctreeBlockContentAdded(node: FrustumStructures.TileNode) {

        // Add node into octree (or something like this).
        this._blockContentToAdd[node.id] = node;
    }
    public onNodeRemoved(node: FrustumStructures.TileNode) {

        this._toRemoveNodesArray.push(node.id);
    }

    private _afterRender = () => {

        if (!this._init) return;

        if (this._blocksToAdd.length == 0) {
            return;
        }

        //TODO make sure update runs as fast as possible to be able to update 60 FPS.
        if (this._runningUpdated > 1) {
            return;
        }

        ++this._runningUpdated;

        var payload: UpdatePayload = {
            updatedBlocks: this._blocksToAdd,
            updatedBlockContent: this._blockContentToAdd,
            removedNodes: this._toRemoveNodesArray
        };
        var message: FrustmMeshMessage = {
            payload: payload,
            taskType: WorkerTaskType.UPDATE
        }
        var serializable: any = [];

        this._worker.postMessage(message, serializable);

        this._addUpdateNodeList = {};
        this._blockContentToAdd = {};
        this._blocksToAdd = [];
        this._toRemoveNodesArray = [];
    }

    private _onMessageFromWorker = (e: MessageEvent) => {
        var returnData = <WorkerReply>e.data;
        if (returnData.error != WorkerReplyType.SUCCESS) {

            BABYLON.Tools.Warn("error returned from worker!");
            return;
        }

        switch (returnData.taskType) {
            case WorkerTaskType.INIT:
                this._init = true;

                break;
            case WorkerTaskType.UPDATE:
                this._runningUpdated--;
                break;
            case WorkerTaskType.ORDERNODES:
                this._runningCollisionTask = false;
                var returnPayload: FrustumStructures.FrustumRegionReplyPayload = returnData.payload;
                if (!this._updateNodesCallbackArray[returnPayload.collisionId]) return;

                this._updateNodesCallbackArray[returnPayload.collisionId](this._sceneManager, returnPayload.visibleNodes, returnPayload.hiddenNodes);

                //cleanup
                this._updateNodesCallbackArray[returnPayload.collisionId] = undefined;
                break;
        }
    }
}